// images
import React from 'react';
import footerLogo from "../../icons/footerLogo.png";
import zacat from "../../icons/zacat.png";
import face from "../../icons/face.png";
import ig from "../../icons/ig.png";
import twitter from "../../icons/twitter.png";
import youtube from "../../icons/youtube.png";
import linked from "../../icons/linked.png";
import whats from "../../icons/whats.png";
import googlePlay from "../../icons/googlePlay.png";
import appStore from "../../icons/appStore.png";
// imports
import "./Footer.scss";
import { Button, Stack, Typography } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import { HashLink as Hash } from 'react-router-hash-link';
import GoDaddySSL from '../goddady-ssl/goddady-ssl';


const Footer = () => {

  const navigate = useNavigate()

  if (localStorage.getItem("lang") === "en") {
    return (
      <div className="Footer" id="footer">
        <div className="container">
          <Stack direction={{ xs: "column", md: "row" }} alignItems={{ xs: "center", md: "flex-end" }} spacing={{ xs: 25, md: 100 }}>

            <Stack
              sx={{
                bgcolor: "white",
                py: 18,
                pl: { xs: 10, md: 28 },
                pr: { xs: 20, md: 48 },
                pb: 25,

              }}
            >
              <div className="logo">
                <img src={footerLogo} alt="" />
              </div>

              <Typography
                variant="h5"
                sx={{
                  fontWeight: "700",
                  fontSize: { xs: "18px", md: "26px" },
                  lineHeight: "30px",
                  color: "text.secondary",
                  mb: 14,
                }}
              >
                Lean Finance is a simple and dynamic online
                e-Invoicing software that helps you grow your
                business.
              </Typography>

              <Typography
                variant="h6"
                sx={{
                  fontSize: "16px",
                  fontWeight: "400",
                  lineHeight: "20px",
                  mb: 16,
                }}
              >
                Issue, manage, send your ZATCA approved e-Invoices and{" "}
                <br /> calculate your tax in seconds.
              </Typography>

              <Typography variant="h6">
                Approved by
              </Typography>

              <div className="zacat"><img src={zacat} alt="" /></div>

              <Button
                onClick={() => navigate("/demo")}
                sx={{
                  width: "fit-content",
                  py: 8, px: 20, mt: 13,
                  borderRadius: "16px",
                  "&:hover": { color: "secondary.main" },
                }} variant="contained" ><Link to="/demo" >Experience it today</Link></Button>
            </Stack>

            <Stack>

              <Stack direction="row" spacing={{ xs: 1, md: 1 }}
                justifyContent={{ xs: "space-between" }} sx={{ color: "white", mb: { xs: 1, md: 1 } }} >
                <div className="list">
                  <h2>Sitemap</h2>
                  <Link to="/">Overview</Link>
                  <Hash to="/#features">Features</Hash>
                  <Link to="/caseStudy">Case Studies</Link>
                  <Hash to="/#industry">Industries</Hash>
                  <Link to="/media">Media Center</Link>
                  <Link to="/login" >Login</Link>
                  <Link to="/demo" style={{ textTransform: "none" }}>Book a demo</Link>
                </div>
                <div className="list">
                  <h2>About Us</h2>
                  <Link to="https://ertikaz.tech" target="_blank" >Ertikaz Solutions</Link>
                </div>

              </Stack>
              <Stack direction="row" spacing={{ xs: 1, md: 1 }}
                justifyContent={{ xs: "space-between" }} sx={{ color: "white", mb: { xs: 1, md: 1 } }} >

                <div className="list">
                  <h2>Contact Us</h2>
                  <li className="email">Info@Ertikaz.tech</li>
                  <li className="email">Sales@Ertikaz.tech </li>
                  <li>+966 534 470 076</li>
                  <li>+966 534 479 020</li>
                </div>

                <div className="list">
                  <h2>Other links</h2>
                  <Link to="https://ertikaz.tech" target="_blank" >Ertikaz</Link>
                  <Link to="https://leandispatcher.ertikaz-tech.com" target="_blank" >Lean Dispacher</Link>
                </div>

              </Stack>

              <Stack direction={{ xs: "column", md: "row" }} alignItems={{ xs: "flex-start", md: "center" }} spacing={{ xs: 10, md: 20 }} mb={20}>
                <a href="https://apps.apple.com/us/app/lean-finance/id6444869765" target="_blank" rel="noreferrer">
                  <img src={appStore} alt="" />
                </a>
                <a href="https://play.google.com/store/apps/details?id=com.ertikaz.leanfinance" target="_blank" rel="noreferrer"><img src={googlePlay} alt="" /></a>
              </Stack>

              <Stack direction="row" alignItems="center" spacing={8} mb={30} className="socialMedia">
                <Link to="https://www.youtube.com/@ertikazTechnology" target="_blank" >
                  <img src={youtube} alt="" />
                </Link>
                <Link to="https://www.instagram.com/ertikazofficial" target="_blank" >
                  <img src={ig} alt="" />
                </Link>
                <Link to="https://www.linkedin.com/company/ertikazsolutions/mycompany/?viewAsMember=true" target="_blank" >
                  <img src={linked} alt="" />
                </Link>
                <Link to="https://x.com/ertikazsolution?s=21&t=uK7TZkh_uM1EU56mB6XfnA" target="_blank" >
                  <img width="28" src={twitter} alt="" />
                </Link>
                <Link to="https://web.facebook.com/profile.php?id=100089105286837" target="_blank" >
                  <img src={face} alt="" />
                </Link>
                <Link to="https://api.whatsapp.com/send?phone=966550379547&text=Welcome%20To%20Lean%20Finance" target="_blank" >
                  <img src={whats} alt="" />
                </Link>
              </Stack>

              <Typography variant="h6" sx={{ fontSize: "18px", color: "#F1EFF4", textAlign: "center" }}>
                Copyright © 2026-2027
                <strong> <a href="https://ertikaz.tech/" rel="noreferrer" target="_blank">Ertikaz Solutions</a> </strong>
                Inc. <br /> All Rights Reserved

                <GoDaddySSL />
              </Typography>

            </Stack>

          </Stack>
        </div>
      </div>
    );
  } else {
    return (
      <div className="Footer" id="footer">
        <div className="container">
          <Stack direction={{ xs: "column", md: "row" }} alignItems={{ xs: "center", md: "flex-end" }} spacing={{ xs: 25, md: 100 }}>

            <Stack
              sx={{
                bgcolor: "white",
                py: 18,
                pl: { xs: 10, md: 28 },
                pr: { xs: 20, md: 48 },
                pb: 25,

              }}
            >
              <div className="logo">
                <img src={footerLogo} alt="" />
              </div>

              <Typography
                variant="h5"
                sx={{
                  fontWeight: "700",
                  fontSize: { xs: "18px", md: "24px" },
                  lineHeight: "30px",
                  color: "text.secondary",
                  mb: 14,
                }}
              >
                لين فايننس هو برنامج بسيط ومرن لإصدار الفواتير الإلكترونية عبر الإنترنت لمساعدتك على تطوير أعمالك
              </Typography>

              <Typography
                variant="h6"
                sx={{
                  fontSize: "16px",
                  fontWeight: "400",
                  lineHeight: "20px",
                  mb: 16,
                }}
              >
                إصدار، إدارة، إرسال الفواتير الإلكترونية المعتمدة من هيئة الزكاة والضريبة والجمارك <br /> وحساب الضريبة الخاصة بك في ثوان.
              </Typography>

              <Typography variant="h6" sx={{ mb: 4 }}>
                معتمد من قبل
              </Typography>

              <div className="zacat"><img src={zacat} alt="" /></div>

              <Button
                onClick={() => navigate("/demo")}
                sx={{
                  width: "fit-content",
                  py: 8, px: 20, mt: 13,
                  borderRadius: "16px",
                  "&:hover": { color: "secondary.main" },
                }} variant="contained" ><Link to="/demo" >جربه اليوم</Link></Button>
            </Stack>

            <Stack>

              <Stack direction="row" flex="1" spacing={{ xs: 1, md: 1 }}
                justifyContent={{ xs: "space-between" }} sx={{ color: "white", mb: { xs: 1, md: 1 } }} >
                <div className="list">
                  <h2>خريطة الموقع</h2>
                  <Link to="/">الرئيسية</Link>
                  <Hash to="/#features">الميزات</Hash>
                  <Link to="/caseStudy">الدراسات</Link>
                  <Hash to="/#industry">القطاعات</Hash>
                  <Link to="/media">الإعلام</Link>
                  <Link to="/login" >تسجيل الدخول</Link>
                  <Link to="/demo">احجز عرض توضيحي</Link>
                </div>
                <div className="list">
                  <h2>من نحن</h2>
                  <Link to="https://ertikaz.tech" target="_blank" >ارتكاز سولوشنز</Link>
                </div>

              </Stack>
              <Stack direction="row" flex="1" spacing={{ xs: 1, md: 1 }}
                justifyContent={{ xs: "space-between" }} sx={{ color: "white", mb: { xs: 1, md: 1 } }} >

                <div className="list fist">
                  <h2>اتصل بنا</h2>
                  <li className="email">Info@Ertikaz.tech</li>
                  <li className="email">Sales@Ertikaz.tech </li>
                  <li>+966 534 470 076</li>
                  <li>+966 534 479 020</li>
                </div>
                <div className="list">
                  <h2>روابط إضافية</h2>
                  <Link to="https://ertikaz.tech" target="_blank" >إرتكاز</Link>
                  <Link to="https://leandispatcher.ertikaz-tech.com" target="_blank" >لين دسباتشر</Link>
                </div>

              </Stack>

              <Stack direction={{ xs: "column", md: "row" }} alignItems={{ xs: "flex-start", md: "center" }} spacing={{ xs: 10, md: 20 }} mb={20}>
                <a href="https://apps.apple.com/us/app/lean-finance/id6444869765" target="_blank" rel="noreferrer">
                  <img src={appStore} alt="" />
                </a>
                <a href="https://play.google.com/store/apps/details?id=com.ertikaz.leanfinance" target="_blank" rel="noreferrer"><img src={googlePlay} alt="" /></a>
              </Stack>

              <Stack direction="row" alignItems="center" spacing={8} mb={30} className="socialMedia">
                <Link to="https://www.youtube.com/@ertikazTechnology" target="_blank" >
                  <img src={youtube} alt="" />
                </Link>
                <Link to="https://www.instagram.com/ertikazofficial" target="_blank" >
                  <img src={ig} alt="" />
                </Link>
                <Link to="https://www.linkedin.com/company/ertikazsolutions/mycompany/?viewAsMember=true" target="_blank" >
                  <img src={linked} alt="" />
                </Link>
                <Link to="https://x.com/ertikazsolution?s=21&t=uK7TZkh_uM1EU56mB6XfnA" target="_blank" >
                  <img width="28" src={twitter} alt="" />
                </Link>
                <Link to="https://web.facebook.com/profile.php?id=100089105286837" target="_blank" >
                  <img src={face} alt="" />
                </Link>
                <Link to="https://api.whatsapp.com/send?phone=966550379547&text=Welcome%20To%20Lean%20Finance" target="_blank" >
                  <img src={whats} alt="" />
                </Link>
              </Stack>

              <Typography variant="h6" sx={{ fontSize: "18px", color: "#F1EFF4", textAlign: "center" }}>
                حقوق النشر © 2026-2027 شركة <strong> <a href="https://ertikaz.tech/" rel="noreferrer" target="_blank">ارتكاز سولوشنز.</a> </strong> <br /> جميع الحقوق محفوظة.
                <GoDaddySSL />
              </Typography>

            </Stack>

          </Stack>
        </div>
      </div>
    );
  }
};

export default Footer;
